import React, { useState } from "react";
import ContadorAnimado from "../components/ContadorAnimado";
import { ReactComponent as FlagIcon } from "../assets/icons/flag.svg";
import { ReactComponent as EyeIcon } from "../assets/icons/eye.svg";
import { ReactComponent as StarIcon } from "../assets/icons/star.svg";
import "../assets/styles/QuemSomos.css";

const highlights = [
  { title: "Nossa história", text: "Desde 2015, a MDA transforma experiência em soluções de segurança, automação e energia solar para famílias e empresas em Goiás." },
  { title: "O que fazemos", text: "Cuidamos de toda a jornada: análise de viabilidade, projeto, instalação, monitoramento, manutenção e limpeza dos equipamentos." },
  { title: "Por que escolher a MDA", text: "Você conta com consultores treinados, equipamentos certificados e acompanhamento próximo antes, durante e depois da instalação." },
];

const QuemSomosPage: React.FC = () => {
  const [activeHighlight, setActiveHighlight] = useState(0);
  const whatsapp = "https://wa.me/5562981368378";

  return <div className="about-page bg-gray-50">
    <section className="about-intro">
      <div className="container about-intro-grid">
        <div>
          <span className="about-kicker">MDA ENERGIA SOLAR · DESDE 2015</span>
          <h1>Energia solar com confiança e acompanhamento de verdade.</h1>
          <p>Somos uma empresa goiana que ajuda casas e empresas a economizarem com projetos solares feitos para a realidade de cada cliente.</p>
          <a className="hero-cta" href={whatsapp} target="_blank" rel="noreferrer">Fale com a MDA ↗</a>
        </div>
        <div className="about-highlight-panel">
          <div className="about-tabs" role="tablist" aria-label="Sobre a MDA">
            {highlights.map((item, index) => <button key={item.title} className={activeHighlight === index ? "active" : ""} onClick={() => setActiveHighlight(index)} role="tab" aria-selected={activeHighlight === index}>{item.title}</button>)}
          </div>
          <div className="about-highlight-content"><span>0{activeHighlight + 1}</span><h2>{highlights[activeHighlight].title}</h2><p>{highlights[activeHighlight].text}</p></div>
        </div>
      </div>
    </section>

    <section className="about-values">
      <div className="container"><div className="about-values-heading"><span className="about-kicker">NOSSO JEITO DE TRABALHAR</span><h2>Clareza em cada etapa do projeto</h2></div>
        <div className="about-values-grid">
          <article><FlagIcon /><h3>Missão</h3><p>Entregar soluções eficientes e atendimento próximo, garantindo segurança e satisfação em cada projeto.</p></article>
          <article><EyeIcon /><h3>Visão</h3><p>Ser reconhecida em Goiás pela excelência em energia solar e pela confiança construída com nossos clientes.</p></article>
          <article><StarIcon /><h3>Valores</h3><p>Transparência, responsabilidade técnica, respeito e compromisso com resultados que fazem diferença.</p></article>
        </div>
      </div>
    </section>

    <section className="bg-gray-700 text-white about-stats"><div className="container"><div className="header-stats"><div className="stat-item"><strong>+ de <ContadorAnimado final={340} /></strong> clientes felizes</div><div className="stat-item"><strong>+ de <ContadorAnimado final={358} /></strong> instalações</div><div className="stat-item"><strong>+ de <ContadorAnimado final={2184} suffix=" kW" /></strong> instalados</div></div></div></section>
    <section className="cta-section about-final-cta"><div className="container"><span className="about-cta-kicker">SUA CONTA DE LUZ PODE SER MENOR</span><h2 className="section-title center">Pare de pagar caro por energia</h2><p>Converse com um especialista da MDA e descubra o melhor projeto solar para reduzir sua conta com segurança.</p><a href={whatsapp} target="_blank" rel="noreferrer" className="whatsapp-button"><i className="fab fa-whatsapp" /> Quero descobrir minha economia</a></div></section>
  </div>;
};

export default QuemSomosPage;
